import React from "react";
import s from "./popUp.module.css";

function PopUp() {
  return (
    <div className={s.containerPopup}>
      <div className={s.popup}>
  {/*        <p className={s.popupText2}>Уважаемые Партнёры и Коллеги! </p>
            <p className={s.popupText1}>Поздравляем вас с Рождеством и Новым годом!</p>
            <p className={s.popupText2}>График работы ООО "ПремексБел":</p>
            <p className={s.popupText3}>с 31.12.2024г. по 07.01.2025г. - выходной</p>
            <p className={s.popupText4}>По всем возникающим вопросам обращайтесь по телефонам:</p>
            <p className={s.popupText4}>+37544 512-81-12 Надежда, +37529 696-31-91 Татьяна, +37529 374-20-65 Оксана</p>

         <p className={s.popupText2}>Уважаемые Партнёры и Коллеги! </p>
            <p className={s.popupText2}>График работы ООО "ПремексБел":</p>
            <p className={s.popupText3}>11.07.2025 – c 8-45 до 12-00</p>
            <p className={s.popupText3}>12.07.2025 – выходной</p>
            <p className={s.popupText4}>По всем возникающим вопросам обращайтесь по телефонам:</p>
            <p className={s.popupText4}>+375 44 512-81-12 Надежда, +375 29 696-31-91 Татьяна, +375 29 374-20-65 Оксана</p> 
      */}
            <p className={s.popupText3}> <span className={s.popupSpan}>Новая услуга!</span> Поверка счетчиков воды и тепла — быстро и официально.</p>
             <p className={s.popupText2}>Осуществляем поверку счетчиков воды и тепла диаметром Ду15 и Ду20:</p>
            <p className={s.popupText2}>- сертифицированные специалисты;</p>
            <p className={s.popupText2}>- официальные документы по результатам поверки.</p>
            <p className={s.popupText4}>контактный телефон: +375 29 305-68-33</p>

      
      </div>
    </div>
  );
}

export default PopUp;
